import React, {useState} from "react";
import {connect} from "react-redux";
import Panel from "../panel/Panel";
import Form from "./forms/Edit";
import {removeAction as removePanelAction} from "../../actions/panel";
import { CrownOutlined, UserOutlined } from '@ant-design/icons';
import { Button, Result, Spin } from "antd";
import EntityLoader from "../common/EntityLoader";

const Title = ({entity}) => <span>
    <CrownOutlined /><UserOutlined /> {!!entity ? entity.name : '404 - Not Found'}
</span>;

const Content = connect(
    null,
    dispatch => ({
        onRemovePanel: (uniqueKey) => dispatch(removePanelAction(uniqueKey)),
    })
)(({entity, entityId, onRemovePanel}) => <>
    {entity
        ? <Form customerId={entityId}/>
        : <Result
            status="404"
            title="404"
            subTitle="Sorry, the page you visited does not exist."
            extra={<Button type="primary" onClick={() => onRemovePanel(`customers:${entityId}:edit`)}>close</Button>}
        />
    }
</>);

export default ({customerId}) => {
    const [loading, setLoading] = useState(true);

    return <Panel
        id={`customers:${customerId}:edit`}
        title={
            <EntityLoader entityId={customerId}>
                <Title/>
            </EntityLoader>
        }
    >
        <Spin spinning={loading}>
            <EntityLoader entityId={customerId} onFinally={() => setLoading(false)}>
                <Content/>
            </EntityLoader>
        </Spin>
    </Panel>
};
